import React from 'react';
import { Stack } from '@mui/material';

const SvgLeft = () => (
  <svg
    width='105'
    height='400'
    viewBox='0 0 105 400'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_5968_2400)'>
      <circle opacity='0.2' cx='34' cy='293' r='70' stroke='#8C9FFF' strokeWidth='2' />
    </g>
    <defs>
      <clipPath id='clip0_5968_2400'>
        <rect width='105' height='400' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

const SvgRight = () => (
  <svg
    width='640'
    height='400'
    viewBox='0 0 640 400'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_5968_2354)'>
      <ellipse cx='462.5' cy='309.5' rx='121.5' ry='120.5' fill='url(#paint0_linear_5968_2354)' />
      <path
        d='M583.75 213C583.75 237.16 563.941 256.75 539.5 256.75C515.059 256.75 495.25 237.16 495.25 213C495.25 188.84 515.059 169.25 539.5 169.25C563.941 169.25 583.75 188.84 583.75 213Z'
        stroke='#222437'
        strokeWidth='0.5'
      />
      <g opacity='0.2'>
        <rect x='0.111328' y='17.8091' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='0.111328' y='43.6177' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='0.111328' y='69.4268' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='0.111328' y='95.2358' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='0.111328' y='121.044' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='25.9202' y='17.8091' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='25.9202' y='43.6177' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='25.9202' y='69.4268' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='25.9202' y='95.2358' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='25.9202' y='121.044' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='51.729' y='17.8091' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='51.729' y='43.6177' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='51.729' y='69.4268' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='51.729' y='95.2358' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='51.729' y='121.044' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='77.5378' y='17.8091' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='77.5378' y='43.6177' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='77.5378' y='69.4268' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='77.5378' y='95.2358' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='77.5378' y='121.044' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='103.347' y='17.8091' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='103.347' y='43.6177' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='103.347' y='69.4268' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='103.347' y='95.2358' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='103.347' y='121.044' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='129.156' y='17.8091' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='129.156' y='43.6177' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='129.156' y='69.4268' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='129.156' y='95.2358' width='5.95588' height='5.95588' fill='#8C9FFF' />
        <rect x='129.156' y='121.044' width='5.95588' height='5.95588' fill='#8C9FFF' />
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_5968_2354'
        x1='526.824'
        y1='189'
        x2='396.719'
        y2='402.145'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#6864D1' />
        <stop offset='1' stopColor='#2F3452' />
      </linearGradient>
      <clipPath id='clip0_5968_2354'>
        <rect width='640' height='400' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

const SVG_BOTTOM_HEIGHT = 4;
const SvgBottom = () => (
  <svg
    preserveAspectRatio='none' // used to stretch to full width
    viewBox='0 0 1455 4'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{
      position: 'absolute',
      width: '100%',
      height: SVG_BOTTOM_HEIGHT,
      bottom: -SVG_BOTTOM_HEIGHT,
    }}
  >
    <rect width='363.75' height='4' fill='#8C9FFF' />
    <rect x='362.46' width='365.04' height='4' fill='#6864D1' />
    <rect x='727.5' width='363.75' height='4' fill='#FF5719' />
    <rect x='1091.25' width='363.75' height='4' fill='#F8931C' />
  </svg>
);

const BACKGROUND_COLOR = '#2F3451';
const BACKGROUND_HEIGHT = '400px';
export const HeroSectionBackground: React.FC = () => {
  // As SVG is absolute, box have position relative and 0 height which sticks SVG to the top.
  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      sx={{
        zIndex: -1,
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        height: BACKGROUND_HEIGHT,
        backgroundColor: BACKGROUND_COLOR,
      }}
    >
      <SvgLeft />
      <SvgRight />
      <SvgBottom />
    </Stack>
  );
};
